import type { LabelHTMLAttributes, ReactNode } from 'react';

interface FieldProps extends LabelHTMLAttributes<HTMLLabelElement> {
  label: ReactNode;
  hint?: ReactNode;
}

export function Field({ label, hint, children, ...rest }: FieldProps): JSX.Element {
  return (
    <label className="flex flex-col gap-1.5" {...rest}>
      <span className="label-sm">{label}</span>
      {children}
      {hint ? <span className="text-xxs text-text-mute">{hint}</span> : null}
    </label>
  );
}
